import { PolicyFlowConference } from 'src/types'

export default function sanitize(values: PolicyFlowConference) {
  try {
    const sanitized = JSON.parse(JSON.stringify(values))
    delete sanitized.key
    sanitized.policy_conference_id = +values.policy_conference_id || null
    return sanitized
  } catch (err) {
    //send bugsnag
  }
}
